var option_webview_default = {
  "option": "_-9A3Q",
  "user_choice": "ChLeH",
  "check": "AIwLQ",
  "image": "onPzO",
  "input": "IWZAX",
  "title": "kBi2H",
  "centered": "fhL6B",
  "with_result": "LzAQL",
  "list": "_--Tfn",
  "with_image": "_9XniX",
  "progress": "wm6QT",
  "progress_value": "LA4y3",
  "label": "bEMaN",
  "cta": "c2blO",
  "adornment_icon": "NUE5D",
  "remove": "tRb0o",
  "removeButton": "Ej1ch",
  "removeButtonIcon": "detaf",
  "overlay": "YpXbC",
  "shown": "OL528",
  "dark": "aTF0p",
  "spinner": "lRwCa",
  "spin": "L3uSX",
  "grid": "uTyBe"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
